import { render, staticRenderFns } from "./Cooperatives.vue?vue&type=template&id=6752547c&"
import script from "./Cooperatives.vue?vue&type=script&lang=js&"
export * from "./Cooperatives.vue?vue&type=script&lang=js&"
import style0 from "./Cooperatives.vue?vue&type=style&index=0&id=6752547c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports